import { useState } from "react";

import Modal from "ui-components/Modal";
import Button from "ui-components/Button";
import Divider from "ui-components/Divider";
import InputField from "ui-components/Input-Field";
import FilterSummary from "ui-components/Data-Filters/Filter-Summary";

import FileFilters from "modules/data-files/elements/File-Filters";

import {
  useGetInputFile,
  useTreatmentDefinition,
  useControlTag,
  useTreatmentTag,
} from "./store";

const setTreatment = () => {
  const currentFile = useGetInputFile();

  const [showModal, setShowModal] = useState(false);

  const [treatment, setTreatment] = useTreatmentDefinition();
  const resetOutcome = () => setTreatment([]);

  const [treatmentTag, setTreatmentTag] = useTreatmentTag();
  const [controlTag, setControlTag] = useControlTag();

  const [view, setView] = useState<"filters" | "tags">("filters");

  return (
    <div className="flex">
      <div className="w-1/4">
        <p className="font-bold">
          3. Define the two groups you want to divide the data into:
        </p>
      </div>
      <div className="w-full">
        {treatment?.length >= 1 ? (
          <div className="pl-2 ml-2">
            <p>
              Rows meeting ALL the below conditions are going to be tagged as{" "}
              <span className="font-semibold underline">{treatmentTag}: </span>{" "}
            </p>
            <ul className="list-decimal ml-2 pl-2 list-inside">
              {treatment.map((d, i) => (
                <li key={i} className="ml-2 pl-2">
                  <FilterSummary filter={d} />
                </li>
              ))}
            </ul>
            <p>
              All other rows shall be marked as{" "}
              <span className="font-semibold underline">{controlTag}</span>
            </p>
            <p className="mt-2">
              Click{" "}
              <span
                onClick={() => {
                  setShowModal(true);
                  setView("filters");
                }}
                className="uppercase text-primary-main cursor-pointer underline"
              >
                here
              </span>{" "}
              to change/edit group definitions, and{" "}
              <span
                onClick={() => {
                  setView("filters");
                  resetOutcome();
                }}
                className="uppercase text-primary-main cursor-pointer underline"
              >
                here
              </span>{" "}
              to reset
            </p>
          </div>
        ) : (
          <p className="text-center pt-2">
            <span
              className="underline text-primary-main cursor-pointer"
              onClick={() => setShowModal(true)}
            >
              Click here
            </span>{" "}
            to define the groups.
          </p>
        )}
        <Modal
          show={showModal}
          handleClose={() => setShowModal(false)}
          id="define-groups"
          ariaLabel="define-groups"
          title="Define groups"
        >
          {view === "filters" ? (
            <div>
              <p className="text-xl font-bold">Setup Group Definitions</p>
              <p className="help">
                Rows that meet ALL the conditions you set are going to be in one
                group. And the rest in the second group.
              </p>

              <FileFilters
                fileId={currentFile}
                filters={treatment}
                updateFilters={setTreatment}
                className="m-2 p-2"
              />
              <Divider />
              <p className="text-right">
                <Button
                  disabled={treatment.length === 0}
                  onClick={() => setView("tags")}
                >
                  Set Tags
                </Button>
              </p>
            </div>
          ) : (
            <div>
              <InputField<string>
                type="text"
                name="tag_ones"
                label="Tag for Meeting All Conditions"
                required
                value={treatmentTag || ""}
                onChange={setTreatmentTag}
                help="What do you want to tag rows that MEET ALL CONDITIONS you defined here, e.g., churned, converted, successful, etc."
              />
              <InputField<string>
                type="text"
                name="tag_zeros"
                label="Tag for Other Rows"
                required
                value={controlTag || ""}
                onChange={setControlTag}
                help="What do you want to tag all other rows?"
              />
              <Divider />
              <p className="text-right">
                <Button
                  disabled={!treatmentTag || !controlTag}
                  onClick={() => setShowModal(false)}
                >
                  Close
                </Button>
              </p>
            </div>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default setTreatment;
